import React from 'react'

const SvgFileWithItemsOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M14 2.186c.293.146.625.417.996.813l4.007 4.006c.427.38.7.712.819.997.119.285.178.618.178 1v11c0 1.333-.667 2-2 2H6.002c-1.335.001-2.002-.666-2.002-2v-16c0-1.333.667-2 2-2h6.996c.058 0 .564-.035 1.004.184zM6 20.002h12.001l-.001-10h-4a2 2 0 01-2-2v-4H6v16zm8-15v3h3l-3-3zm-5 9c-.667 0-1-.333-1-1s.334-1 1.001-1H15c.667 0 1 .333 1 1s-.333 1-1 1H9zm0-4c-.667 0-1-.333-1-1s.334-1 1.001-1H10c.667 0 1 .333 1 1s-.333 1-1 1H9zm0 8c-.667 0-1-.333-1-1s.333-1 1-1h6c.667 0 1 .333 1 1s-.333 1-1 1H9z' />
  </svg>
)

export default SvgFileWithItemsOutline
